(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  class ImageGallery extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.gallery-lightbox');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.prevBtn = this.querySelector('.gallery-lightbox__arrow--prev');
      this.nextBtn = this.querySelector('.gallery-lightbox__arrow--next');
      this.closeBtn = this.querySelector('.gallery-lightbox__close');
      this.counterCur = this.querySelector('.gallery-lightbox__counter-cur');
      this.total = this.slides.length;
      this.index = 0;
      this.touchStartX = null;

      this.querySelector('.image-gallery__grid')?.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-gallery-trigger]');
        if (!btn) return;
        this.open(Number(btn.dataset.galleryTrigger));
      });

      this.closeBtn?.addEventListener('click', () => this.close());
      this.prevBtn?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this.goTo(this.index + 1));

      this.dialog?.addEventListener('click', (e) => {
        if (e.target === this.dialog || e.target === this.querySelector('.gallery-lightbox__stage')) {
          this.close();
        }
      });

      this.dialog?.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
      });

      this.dialog?.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });

      this.dialog?.addEventListener('touchend', (e) => {
        if (this.touchStartX === null) return;
        const delta = e.changedTouches[0].clientX - this.touchStartX;
        this.touchStartX = null;
        if (Math.abs(delta) < 50) return;
        this.goTo(delta < 0 ? this.index + 1 : this.index - 1);
      }, { passive: true });
    }

    open(index) {
      this.goTo(index);
      this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }

    goTo(n) {
      const prev = this.index;
      this.index = ((n % this.total) + this.total) % this.total;
      this.slides[prev]?.classList.remove('is-active');
      this.slides[prev]?.setAttribute('aria-hidden', 'true');
      this.slides[this.index]?.classList.add('is-active');
      this.slides[this.index]?.setAttribute('aria-hidden', 'false');
      if (this.counterCur) this.counterCur.textContent = String(this.index + 1);
    }
  }

  if (!customElements.get('image-gallery')) {
    customElements.define('image-gallery', ImageGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPartnerList(section) {
    var list = section.querySelector('[data-partner-list]');
    if (!list) return;

    var items = Array.from(list.querySelectorAll('.partner-list__item'));
    var countEl = section.querySelector('[data-partner-count]');
    var noResultsEl = section.querySelector('[data-no-results]');
    var countrySelect = section.querySelector('[data-filter-key="country"]');
    var toggles = Array.from(section.querySelectorAll('[data-filter-bool]'));
    var resetBtn = section.querySelector('[data-reset-filters]');

    function applyFilters() {
      var selectedCountry = countrySelect ? countrySelect.value : '';
      var activeBools = toggles
        .filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })
        .map(function (t) { return t.getAttribute('data-filter-bool'); });

      var visible = 0;
      items.forEach(function (item) {
        var show = true;
        if (selectedCountry && item.getAttribute('data-country') !== selectedCountry) show = false;
        if (show) {
          activeBools.forEach(function (key) {
            if (item.getAttribute('data-' + key) !== 'true') show = false;
          });
        }
        item.hidden = !show;
        if (show) visible++;
      });

      if (countEl) {
        var tpl = visible === 1 ? countEl.dataset.countOne : countEl.dataset.countOther;
        countEl.textContent = tpl.replace('__COUNT__', visible);
      }
      if (noResultsEl) noResultsEl.hidden = visible > 0;
    }

    if (countrySelect) countrySelect.addEventListener('change', applyFilters);

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var active = toggle.getAttribute('aria-pressed') === 'true';
        toggle.setAttribute('aria-pressed', String(!active));
        toggle.classList.toggle('is-active', !active);
        applyFilters();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (countrySelect) countrySelect.value = '';
        toggles.forEach(function (t) {
          t.setAttribute('aria-pressed', 'false');
          t.classList.remove('is-active');
        });
        applyFilters();
      });
    }

    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.section-partner-list').forEach(initPartnerList);
    });
  } else {
    document.querySelectorAll('.section-partner-list').forEach(initPartnerList);
  }
}());

  } catch(e) { console.error(e); }
})();
})();
